import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2023 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { useState } from "react";
import { DateRangePicker } from "rsuite";
import { stopPropagation } from "../general/utils";
import { setFilter, filterListener } from "./utils";
import FilterToggle from "./FilterToggle";
function FilterDatePicker(props) {
    const { attribute, componentId, rename, zone, setZone } = props;
    const [value, setValue] = useState();
    const [disabled, setDisabled] = useState(false);
    const [exists, setExists] = useState(false);
    const [negate, setNegate] = useState(false);
    filterListener({
        attribute: attribute,
        componentId: componentId,
        operators: ["gte", "lt"],
        zone: zone,
        setValue: setValue,
        setExists: setExists,
        setNegate: setNegate,
        setDisabled: setDisabled,
        emptyValue: null,
        zoneToValue: (filterValue, exisitingValue) => {
            if (exisitingValue === null)
                return filterValue; // first iteration
            return [new Date(exisitingValue), new Date(filterValue)]; // second iteration
        },
    }, [zone]);
    const onFilter = (input) => {
        const from = input !== null ? new Date(input[0]) : null;
        const to = input !== null ? new Date(input[1]) : null;
        if (from !== null)
            from.setHours(0, 0, 0, 0);
        if (to !== null)
            to.setHours(23, 59, 59, 999);
        setValue(input);
        setFilter({
            operator: "gte",
            value: from,
            negate: negate,
            attribute: attribute,
            componentId: componentId,
            zone: zone,
            valueExists: from !== null,
        });
        setFilter({
            operator: "lt",
            value: to,
            negate: negate,
            attribute: attribute,
            componentId: componentId,
            zone: zone,
            valueExists: to !== null,
        });
        setZone({ ...zone });
    };
    const onExists = (ex) => {
        setExists(!ex);
        setValue(null);
        setFilter({
            operator: "exists",
            negate: negate,
            exists: !ex,
            attribute: attribute,
            componentId: componentId,
            zone: zone,
        });
        setZone({ ...zone });
    };
    const onNegate = (ng) => {
        const from = value !== null ? new Date(value[0]) : null;
        const to = value !== null ? new Date(value[1]) : null;
        if (from !== null)
            from.setHours(0, 0, 0, 0);
        if (to !== null)
            to.setHours(23, 59, 59, 999);
        setNegate(!ng);
        setFilter({
            operator: exists ? "exists" : "gte",
            value: from,
            negate: !ng,
            exists: exists,
            attribute: attribute,
            componentId: componentId,
            zone: zone,
            valueExists: from !== null,
        });
        setFilter({
            operator: exists ? "exists" : "lt",
            value: to,
            negate: !ng,
            exists: exists,
            attribute: attribute,
            componentId: componentId,
            zone: zone,
            valueExists: to !== null,
        });
        setZone({ ...zone });
    };
    return (_jsxs("div", { className: "tol-date-filter", onClick: stopPropagation, children: [_jsx(DateRangePicker, { block: true, 
                // @ts-ignore
                onChange: onFilter, value: value, placeholder: rename, format: "dd/MM/yyyy", disabled: disabled, preventOverflow: true }), _jsx(FilterToggle, { negate: negate, onNegate: onNegate, exists: exists, onExists: onExists, disabled: disabled })] }));
}
export default FilterDatePicker;
